// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__iPdZu","line":"Loading_line__QbdKT","line-animation":"Loading_line-animation__x2IPN","invert":"Loading_invert__rAzw0","small":"Loading_small__mRwWg"};